// @ts-check

/** @file Durable non-secret installation identity for idempotent sync mutations. */

import Option from "../models/option.js"
import {flushLocalDatabaseWrites} from "../shared/local-database-persistence.js"
import {syncUuid} from "../database/project-replica-mutation-log.js"

const DEVICE_ID_KEY = "project-sync-device-id-v1"

/**
 * Loads or creates the installation identity used for idempotent mutations.
 * @returns {Promise<string>} Stable installation UUID.
 */
export async function projectSyncDeviceId() {
  const option = await Option.findOrInitializeBy({key: DEVICE_ID_KEY})
  let value = option.value()

  if (!value) {
    value = syncUuid()
    option.setValue(value)
    await option.save()
    await flushLocalDatabaseWrites()
  }

  return value
}
